import { ColumnDef, Updater } from '@tanstack/react-table';
import type { JSX } from 'react';
import { PlacesType } from 'react-tooltip';

export const WIDTH_AUTO = -1;

export enum Separator {
  'RIGHT_SIDE_ONLY' = 'RIGHT_SIDE_ONLY',
  'LEFT_SIDE_ONLY' = 'LEFT_SIDE_ONLY',
  'NONE' = 'NONE',
}

export type StickyPosition = 'left' | 'right';

export type CustomColumnDef<T> = ColumnDef<T> & {
  visible?: boolean;
  defaultHidden?: boolean;
  sticky?: boolean | StickyPosition;
  multiline?: boolean;
  downloadDimensions?: string[];
  headerCellSeparator?: keyof typeof Separator;
  getSearchableValue?: (value: unknown, row: T) => unknown;
  getHighlightValue?: (value: unknown, row: T) => string | number | null | undefined;
  // This props is need for icon tooltip in cell. If this is set to true - tooltip will be displayed for icon
  displayTooltipForIcon?: boolean;
  additionalContentCellClassname?: string;
  mergedGroup?: string;
  columnConfigLabel?: string;
  columnConfigSection?: string;
  tooltipPlace?: PlacesType;
};

export const defaultCustomColumnDef = {
  visible: true,
  sticky: false,
  enableGrouping: false,
};

export const isUpdateFn = <T>(x: Updater<T>): x is (old: T) => T => typeof x === 'function';

export type AdditionalHeaderDefinition = {
  label: string | JSX.Element;
  enableSorting: boolean;
};

export type DescriptionRow = {
  [key: string]: string | JSX.Element | AdditionalHeaderDefinition;
};

export * from './tableOptions';
export * from './tableTab';
